import type { Dayjs } from 'dayjs';

interface IVersionLike {
  startedAt?: string | null;
}

export interface IShouldQueryPreviousPeriodParams {
  isQueryPreviousData: boolean;
  versions: ReadonlyArray<IVersionLike | null | undefined> | null | undefined;
  previousEndDate: Dayjs;
}

/**
 * Returns false when the previous window ends before the campaign first started —
 * the server would respond with no rows, so the round-trip is wasted. Fails open
 * (returns true) when version metadata is missing or unparseable, preserving the
 * original "always fetch previous" behavior.
 */
export const shouldQueryPreviousPeriod = ({
  isQueryPreviousData,
  versions,
  previousEndDate,
}: IShouldQueryPreviousPeriodParams): boolean => {
  if (!isQueryPreviousData) return false;
  if (!versions?.length) return true;

  const startTimestamps = versions
    .map((v) => v?.startedAt)
    .filter((startedAt): startedAt is string => !!startedAt)
    .map((startedAt) => new Date(startedAt).getTime())
    .filter((ts) => !Number.isNaN(ts));

  if (!startTimestamps.length) return true;
  return previousEndDate.valueOf() > Math.min(...startTimestamps);
};
